






















































































































































































































import {Component, Mixins} from 'vue-property-decorator';

import ContentSection from '@/components/ContentSection.vue';
import {IContentSection} from '@/components/types';
import PricingPlans from '@/components/PricingPlans.vue';
import Icon from '@/components/ui/Icon.vue';

import {gsap, ScrollTrigger} from '@/utils/gsap';
import ScrollTo from '@/mixins/ScrollTo';
import {TranslateResult} from 'vue-i18n';
import checkIE from '@/utils/ie';

@Component({
	components: {
		'v-content-section': ContentSection,
		'v-pricing-plan': PricingPlans
	}
})
export default class Green extends Mixins(ScrollTo) {
	sw: any = [];
	tl: any;
	tlScroll: any;
	currentSlide: number = 0;
	anim: boolean = false;
	ultimateTimeline: any;

	ease: string = 'elastic.out(1, 0.3)';
	easeInOut: string = 'back.inOut(1.7)';
	animationsInited: boolean = false;

	mockup: HTMLElement | null;
	$refs: {
		visualCard: Icon
		visual: ContentSection

		orkaCardGreen: HTMLElement

		carousel: HTMLElement
		background: HTMLElement
		sticky: HTMLElement
		carouselVisualCard: HTMLElement
		animationWrapper: HTMLElement
		content: HTMLElement[]
		contentTrigger: HTMLElement[]

		carouselSlide1: HTMLElement
		carouselSlide2: HTMLElement
		carouselSlide3: HTMLElement

		carouselSlideImage1: HTMLElement
		carouselSlideImage2: HTMLElement
		carouselSlideImage3: HTMLElement

	}

	get content(): IContentSection {
		return {
			headline: this.$t('cards.green.contentSection.headline') as string,
			perex: this.$t('cards.green.contentSection.perex') as string,
			buttons: [
				{
					variant: 'green',
					to: {
						name: this.$route.name!,
						query: {
							modal: this.appModalName
						},
						params: {
							card: 'green'
						}
					},
					label: this.$t('button.get.green') as string
				},
				{
					variant: 'secondary secondary-green',
					onClick: () => this.scrollToSection(this.$refs.carousel),
					label: this.$t('button.learnMore') as string
				}
			],
			icon: 'letters/a'
		};
	}

	get isIE(): boolean {
		return checkIE();
	}

	get backgrounds(): TranslateResult {
		return this.$t('cards.green.slider.sections');
	}

	get appModalName(): string {
		return this.$t('routes.getApp.modalName') as string;
	}

	mounted(): void {

		if (typeof window === 'undefined') {
			return;
		}

		this.tlScroll = gsap.timeline({paused: true});

		this.mockup = document.querySelector('.slider__mockup-overflow');

		this.resizeHandler();
	}

	initAnimations(): void {
		this.ultimateTimeline = gsap.timeline({paused: true});

		this.ultimateTimeline
			.fromTo(this.$refs.carouselSlideImage1,
				{
					xPercent: 100,
					ease: 'none'
				},
				{
					xPercent: 0
				}
			)
			.to(this.$refs.carouselSlide1,
				{
					autoAlpha: 1,
				}
			)
			.to(this.$refs.carouselSlide1.querySelectorAll('.icon'),
				{
					stagger: 0.15,
					autoAlpha: 1,
					scale: 1,
					ease: this.easeInOut
				}
			)
			.to(this.$refs.carouselSlideImage1,
				{
					xPercent: -100
				}
			)
			.to(this.$refs.carouselSlide1.querySelectorAll('.icon'),
				{
					stagger: 0.15,
					autoAlpha: 0,
					scale: 0,
					ease: this.easeInOut
				}
			)
			.fromTo(this.$refs.carouselSlideImage2,
				{
					xPercent: 100,
					ease: 'none'
				},
				{
					xPercent: 0
				}
			)
			.to(this.$refs.carouselSlide2,
				{
					autoAlpha: 1,
				}
			)
			.to(this.$refs.carouselSlide2.querySelectorAll('.icon'),
				{
					stagger: 0.15,
					autoAlpha: 1,
					scale: 1,
					ease: this.easeInOut
				}
			)
			.to(this.$refs.carouselSlideImage2,
				{
					xPercent: -100
				}
			)
			.to(this.$refs.carouselSlide2.querySelectorAll('.icon'),
				{
					stagger: 0.15,
					autoAlpha: 0,
					scale: 0,
					ease: this.easeInOut
				}
			)
			.fromTo(this.$refs.carouselSlideImage3,
				{
					xPercent: 100,
					ease: 'none'
				},
				{
					xPercent: 0
				}
			)
			.to(this.$refs.carouselSlide3,
				{
					autoAlpha: 1,
				}
			)
			.to(this.$refs.carouselSlide3.querySelectorAll('.icon'),
				{
					stagger: 0.15,
					autoAlpha: 1,
					scale: 1,
					ease: this.easeInOut
				}
			);

	}

	initScrollTrigger(): void {

		let sw = ScrollTrigger.create({
			trigger: this.$refs.carousel,
			animation: this.ultimateTimeline,
			start: 'top +=60%',
			end: 'bottom bottom',
			scrub: 1
		});

		this.sw.push(sw);

		if (!this.$refs.contentTrigger) {
			return;
		}

		this.$refs.contentTrigger.forEach((element: HTMLElement) => {
			let sw = ScrollTrigger.create({
				trigger: element,
				onUpdate: (self: any) => {
					this.currentSlide = this.$refs.contentTrigger.indexOf(self.trigger);
				}
			});
			this.sw.push(sw);
		});

	}

	stickyBackground(): void {
		if (!this.$refs.background) {
			return;
		}
		let sw = ScrollTrigger.create({
			trigger: this.$refs.carousel,
			start: 'top top',
			end: 'bottom bottom',
			pin: this.$refs.background,
			pinSpacing: false,
			scrub: 1.5
		});

		this.sw.push(sw);
	}

	stickyScroll(): void {

		if (!this.$refs.sticky) {
			return;
		}

		let sw = ScrollTrigger.create({
			trigger: this.$refs.sticky,
			start: 'top top',
			end: 'bottom bottom',
			pin: true,
			pinSpacing: false
		});

		this.sw.push(sw);
	}

	async cardAnim(): Promise<void> {

		if (!this.$refs.visual) {
			return;
		}

		const card = this.$refs.visual.$el.querySelector('.content-section__card');

		if (!card) {
			return;
		}

		gsap.set(this.$refs.carouselVisualCard, {clearProps: 'all'})

		const {bottom: visualBottom, left: visualLeft, width: visualWidth} = card.getBoundingClientRect();
		const {bottom: cardBottom, left: cardLeft, width: cardWidth} = this.$refs.carouselVisualCard.getBoundingClientRect();

		const offsetY = (visualBottom - cardBottom);
		const offsetX = (visualLeft - cardLeft);

		const wDiff = visualWidth - cardWidth;

		const scale = (wDiff / (cardWidth / 100)) / 100 + 1;

		gsap.set(this.$refs.carouselVisualCard, {
			y: `${offsetY - 25}px`,
			x: `${offsetX + 40}px`,
			transformOrigin: 'center center',
			scale: scale
		});

		this.tlScroll
			.fromTo(this.$refs.carouselVisualCard, {
				y: `${offsetY - 25}px`,
				x: `${offsetX + 40}px`
			}, {
				y: '0px',
				x: '1px',
				rotation: -90
			})
			.to(this.$refs.carouselVisualCard, {
				rotation: 0,
				y: (this.$refs.orkaCardGreen.clientHeight / 2) - (this.$refs.carouselVisualCard.clientHeight / 2),
				x: '50px'
			})
			.to(this.$refs.carouselVisualCard, {
				rotation: 90,
				y: this.$refs.orkaCardGreen.clientHeight - (this.$refs.carouselVisualCard.clientHeight / 1.2),
				x: '0px'
			});

		let sw = ScrollTrigger.create({
			animation: this.tlScroll,
			trigger: this.$refs.carousel,
			start: 'top 80%',
			end: 'bottom bottom',
			scrub: 1
		});

		this.sw.push(sw);

	}

	async resizeHandler(): Promise<void> {

		if (window.innerWidth > 767) {

			await this.initAnimations();

			await this.cardAnim();

			if (this.isIE) {
				await this.stickyBackground();
				await this.stickyScroll();
			}

			await this.initScrollTrigger();

		}
	}

	beforeDestroy() {
		if (this.sw.length === null || typeof this.sw === 'undefined') {
			return;
		}
		this.sw.forEach((scrollTrigger: any) => scrollTrigger.kill());
	}

}
